import { useEffect, useState } from 'react';
import { Icono } from '@xiltrion/ui/icono';
import { Field } from '@/components/ui';
import { Spinner } from '@xiltrion/ui/spinner';
import { Alert, AlertDescription } from '@xiltrion/ui/alert';
import { Button } from '@xiltrion/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@xiltrion/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@xiltrion/ui/select';
import { Textarea } from '@xiltrion/ui/textarea';
import { UserSelect } from '../UserSelect';
import { REASSIGN_REASONS, errorMessage } from '../lib';

/** Reassignment with mandatory reason. Generic: used for cases, tasks and bulk. */
export function ReassignDialog({ visible, onHide, onSubmit, busy, error, currentAssigneeId, title = 'Reasignar', subjectLabel }: {
  visible: boolean; onHide: () => void; onSubmit: (v: { toUserId: string; reasonCode: string; comment?: string }) => void; busy?: boolean; error?: unknown; currentAssigneeId?: string | null; title?: string; subjectLabel?: string;
}) {
  const [userId, setUserId] = useState<string | null>(null);
  const [reason, setReason] = useState<string | null>(null);
  const [comment, setComment] = useState('');
  useEffect(() => { if (!visible) { setUserId(null); setReason(null); setComment(''); } }, [visible]);
  const valid = !!userId && !!reason && (reason !== 'OTHER' || comment.trim().length >= 3);
  return (
    <Dialog open={visible} onOpenChange={(o) => { if (!o) onHide(); }}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <div className="flex flex-col gap-3">
          {subjectLabel && <div className="text-muted-foreground text-sm">{subjectLabel}</div>}
          <Field label="Nueva persona responsable" htmlFor="reassign-user" required><UserSelect value={userId} onChange={setUserId} exclude={currentAssigneeId} inputId="reassign-user" /></Field>
          <Field label="Motivo" htmlFor="reassign-reason" required>
            <Select value={reason ?? ''} onValueChange={setReason}>
              <SelectTrigger id="reassign-reason" className="w-full"><SelectValue placeholder="Selecciona el motivo" /></SelectTrigger>
              <SelectContent>{REASSIGN_REASONS.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
          <Field label="Comentario" htmlFor="reassign-comment" required={reason === 'OTHER'}><Textarea id="reassign-comment" value={comment} onChange={(e) => setComment(e.target.value)} rows={3} placeholder="Contexto para la persona que recibe el caso" /></Field>
          <div className="text-xs text-muted-foreground">El motivo queda registrado en la auditoría del expediente.</div>
          {error ? <Alert variant="destructive"><AlertDescription>{errorMessage(error)}</AlertDescription></Alert> : null}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onHide}>Cancelar</Button>
          <Button disabled={!valid || busy} onClick={() => userId && reason && onSubmit({ toUserId: userId, reasonCode: reason, comment: comment.trim() || undefined })}>{busy ? <Spinner /> : <Icono nombre='mdi:account-edit-outline' />} Reasignar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
